import { Injectable, inject } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { MultisiteService } from '@df/core/service/multisite';
import { Paypal } from '@df/module-paypal/paypal.namespace';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class PaypalPayInThreeService {
    private sdkLoaded = false;
    private request = inject(RequestService);
    private timeoutService = inject(TimeoutService);
    private multisite = inject(MultisiteService);

    async load(componentsId: string) {
        if (!this.sdkLoaded) {
            const clientId = await this.getClientId();

            if (clientId) {
                await this.timeoutService.setTimeout(() => {
                    this.loadSDK(clientId, componentsId);
                }, 100);
            }
        }
    }

    private async getClientId(): Promise<string | undefined> {
        const result = await this.request.send(undefined, { path: Paypal.EXPRESS_ENDPOINTS.buttonConfig }, undefined, undefined, {
            method: 'GET'
        });
        const sdkUrl = new URL(result.sdkUrl);
        return sdkUrl.searchParams.get('client-id') || undefined;
    }

    private async loadSDK(clientId: string, componentsId: string) {
        const sdkUrl = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=${this.multisite.current.currency}&components=${componentsId}`;
        await this.request.loadScript(sdkUrl);
        this.sdkLoaded = true;
    }
}
